module.exports = "<div baCardBlur class=\"animated fadeIn card {{cardType}} {{baCardClass || ''}}\" zoom-in>\r\n  <div *ngIf=\"cardTitle\" class=\"card-header clearfix\">\r\n    <h3 class=\"card-title\" translate>{{cardTitle}}</h3>\r\n  </div>\r\n  <div class=\"card\">\r\n    <div class=\"card-body\">\r\n      <ng-content></ng-content>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baCard/baCard.html
// module id = 1576
// module chunks = 18